import { render, staticRenderFns } from "./fengxianjieguo.vue?vue&type=template&id=0c91020c&scoped=true"
import script from "./fengxianjieguo.vue?vue&type=script&lang=js"
export * from "./fengxianjieguo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c91020c",
  null
  
)

export default component.exports